

export const MarginForward = () => {
    return (
        <svg xmlns="http://www.w3.org/2000/svg" width="21" height="21" viewBox="0 0 21 21" fill="none">
            <rect x="1" y="1" width="19" height="19" stroke="#838280" strokeWidth="1" strokeLinecap="round" strokeLinejoin="round"></rect>
            <path d="M4 17 v -7 l 4 -4 h 7 v 7 l -4 4 v -7 l 4 -4 m -4 4 h -7 m 0 7 h 7" stroke="#838280" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" />

        </svg>
    )
}